
import { RevButton } from '@ds/components/Button'
import { IconCycle } from '@ds/icons/IconCycle'
import { IconGlasses } from '@ds/icons/IconGlasses'
import { IconLeaf } from '@ds/icons/IconLeaf'
import { IconThumbsUpOutlined } from '@ds/icons/IconThumbsUpOutlined'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'
import IllustrationEarth from '@core/illustrations/IllustrationEarth.svg'
import { productRenewedImpactModalFetch } from '@http/endpoints'

import ContentRow from '../../ContentRow'
import AsyncModal from '../AsyncModal'

const ICONS = {
  IconLeaf,
  IconCircle: IconCycle,
  IconThumbsUp: IconThumbsUpOutlined,
  IconGlasses,
}

const ILLUSTRATIONS = {
  IllustrationEarth,
}

export default {
  components: {
    AsyncModal,
    ContentRow,
    RevButton,
  },
  props: {
    productId: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      content: {},
    }
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.RENEWED_IMPACT,

    modalTitle() {
      return this.content.title
    },
    links() {
      return this.content.links
    },
    shouldDisplayLinks() {
      return !isEmpty(this.links)
    },
    renewedImpact() {
      return this.content.paragraphs?.map(({ icon, title, text }) => ({
        icon: ICONS[icon],
        labels: [text],
        title,
      }))
    },
    illustration() {
      return ILLUSTRATIONS[this.content.image]
    },

    id() {
      return this.productId || this.$route.params.uuid
    },
  },
  methods: {
    async fetchRenewedImpact() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productRenewedImpactModalFetch,
        pathParams: { productId: this.id },
      })

      this.content = { ...payload }
    },
  },
}
